function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m7 0c-3.85770203 0-7 3.14229797-7 7 0 3.8577021 3.14229797 7 7 7 3.8577021 0 7-3.1422979 7-7 0-3.85770203-3.1422979-7-7-7zm0 1.4c3.1010861 0 5.6 2.49891418 5.6 5.6 0 3.1010861-2.4989139 5.6-5.6 5.6-3.10108582 0-5.6-2.4989139-5.6-5.6 0-3.10108582 2.49891418-5.6 5.6-5.6zm0 1.4c-1.547 0-2.8 1.253-2.8 2.8h1.4c0-.77.63-1.4 1.4-1.4s1.4.63 1.4 1.4c0 1.4-2.1 1.6569-2.1 3.5h1.4c0-1.1557 2.1-1.75 2.1-3.5 0-1.547-1.253-2.8-2.8-2.8zm-.7 7v1.4h1.4v-1.4z",
  fill: "#3bace0"
});

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.a04bfb8e.svg";
export { ForwardRef as ReactComponent };